module.exports = __webpack_public_path__ + "media/images/author_icons/submitting_author-efd4f1c5b9efdc9c96113105b1c866d6.svg";